module.exports = __webpack_public_path__ + "img/fremont_lofts.7ac39e82.svg";